import React from 'react';
import Heading from '@legacy-vfuk/core-heading';
import RichTextElement from '../pageBuilder/Elements/RichText';
import { VideoSummaryProps } from './types/VideoSummary.types';
import { bgWhite, textBlock } from './styles/Article.styles';
import {
  VideoContainerWrapper,
  videoiframe,
} from './styles/VideoSummary.styles';
import { cardContainer } from './styles/Card.styles';
import { Helmet } from 'react-helmet';
import getYoutubeScript from '../../helpers/youTubeHelper';

const VideoSummary = ({ data }: VideoSummaryProps) => {
  const { videoSummary, slug } = data;

  return (
    <a
      css={[bgWhite, cardContainer]}
      className="card"
      data-testid={`videoSummary-${slug}`}
    >
      <VideoContainerWrapper data-testid="videoContainer">
        <Helmet>
          <script src="https://www.youtube.com/iframe_api"></script>
          <script>{getYoutubeScript()}</script>
        </Helmet>
        <iframe
          css={videoiframe}
          id={`ytplayer_${slug}`}
          src={`https://www.youtube.com/embed/${slug}?rel=0&enablejsapi=1`}
          className="yt-player-custom"
          type="text/html"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        />
      </VideoContainerWrapper>
      <div css={textBlock}>
        <RichTextElement rawRichText={videoSummary.raw} noMargin />
      </div>
    </a>
  );
};

export default VideoSummary;
